module.exports = [{"type":"title","text":"2024-02-23"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續調整接口:調整槓桿接口的side字段支持BOTH值。"},{"type":"html","text":"永續調整接口:下單&批量下單接口中的stopLoss和takeProfit字段不支持傳入quantity字段。"},{"type":"html","text":"永續調整接口:下單&批量下單接口新增closePosition字段。"},{"type":"html","text":"永續調整接口:下單&批量下單接口新增activationPrice字段。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-02-23.json
// module id = NuRj
// module chunks = 3